module.exports = __webpack_public_path__ + "static/media/white.13646829.png";